import { createReducer, on } from '@ngrx/store';
import { UserProfile } from 'src/app/models/user-profile.model';
import * as UserProfileActions from './user-profile.actions';
export interface UserProfileState {
  userProfile: UserProfile | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: UserProfileState = {
  userProfile: null,
  isLoading: false,
  error: null,
};

export const userProfileReducer = createReducer(
  initialState,
  on(UserProfileActions.loadUserProfile, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(UserProfileActions.loadUserProfileSuccess, (state, { userProfile }) => ({
    ...state,
    userProfile,
    isLoading: false,
  })),
  on(UserProfileActions.loadUserProfileFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(UserProfileActions.updateUserProfile, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(UserProfileActions.updateUserProfileSuccess, (state, { userProfile }) => ({
    ...state,
    userProfile,
    isLoading: false,
    error: null,
  })),
  on(UserProfileActions.updateUserProfileFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false,
  }))
);
